export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const BASE_URL_SOCKET = process.env.REACT_APP_API_BASE_URL_SOCKET;
export const BASE_URL_IMAGE = process.env.REACT_APP_IMAGE_URL_FOR_S3;
